export type BreakpointListener = {
  default?: () => void;
  xs?: () => void;
  sm?: () => void;
  md?: () => void;
  lg?: () => void;
  xl?: () => void;
  xl2?: () => void;
};

export const tailwindBreakpoints = {
  'xs': '475px',
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
};
